export default __webpack_public_path__ + "images/30_1_image.jpg";